import type { AppState, MutationClass } from '../../../models'

export class SetFiltersHiddenMutation implements MutationClass {
  static execute(this: void, state: AppState, filtersHidden: boolean): void {
    state.filtersHidden = filtersHidden
  }
}
